import { LinearGradient } from 'expo-linear-gradient';
import React, { forwardRef, Ref } from 'react';
import {
  Platform,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import generateID from '../../utils/generate-id';

type Props = {
  accessibilityLabel?: string;
  id?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  style?: StyleProp<ViewStyle>;
  checked?: boolean;
};

const CheckBox = forwardRef((props: Props, ref: Ref<TouchableOpacity>) => {
  return (
    <TouchableOpacity
      ref={ref}
      onPress={() => props.onChange?.(!props.checked)}
      disabled={props.disabled}
      style={[style.root, props.style]}
      /** Generate HTML and Test IDs  */
      {...generateID(props.id)}
      /** Platform-specific props */
      {...Platform.select({
        web: {
          accessibilityRole: 'checkbox',
          accessibilityDisabled: props.disabled,
        },
      })}
    >
      <LinearGradient
        colors={
          props.disabled ? ['#CFD4D8', '#CFD4D8'] : ['#E5258C', '#823CD7']
        }
        /** will do an approximately 135-degree gradient */
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 6 }}
        style={style.gradient}
      >
        {props.checked ? (
          <View style={style.tickChecked} />
        ) : (
          <View style={style.tickUnchecked} />
        )}
      </LinearGradient>
    </TouchableOpacity>
  );
});

const style = StyleSheet.create({
  root: {
    width: 32,
    height: 32,
    borderRadius: 4,
    overflow: 'hidden',
  },
  gradient: {
    flex: 1,
    padding: 2,
    position: 'relative',
  },
  tickUnchecked: {
    flex: 1,
    backgroundColor: 'white',
    borderRadius: 2,
  },
  tickChecked: {
    borderLeftWidth: 2,
    borderBottomWidth: 2,
    borderColor: 'white',
    borderRadius: 2,
    height: 8,
    width: 16,
    marginLeft: 3,
    marginTop: 4,
    transform: [{ rotate: '-45deg' }],
  },
});

export default CheckBox;
